import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import Card from 'antd/lib/card'
import List from 'antd/lib/list'
import { setCurrentBuilding } from '../lib/setCurrentBuilding'
import loginBackground from '../assets/images/loginBackground.jpg'

const styles = {
    container: {
        position: 'absolute',
        top: '25%',
        left: '38%',
    },
    link: {
        cursor: 'pointer',
        color: '#1BAAF1',
    },
    backgroundContainer: {
        backgroundImage: `url(${loginBackground})`,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        bottom: 0,
        height: '100%',
        left: 0,
        position: 'absolute',
        right: 0,
        top: 0,
    },
}

const BuildingPicker = () => {
    const data = useSelector((state) => state.app.occupancies)

    useEffect(() => {
        document.body.style.backgroundImage = `url(${loginBackground})`
        document.body.style.backgroundPosition = 'center'
        document.body.style.backgroundRepeat = 'no-repeat'
        document.body.style.backgroundSize = 'cover'
        return () => {
            document.body.style.backgroundImage = null
            document.body.style.backgroundPosition = null
            document.body.style.backgroundRepeat = null
            document.body.style.backgroundSize = null
        }
    })

    const generateName = (item) => {
        if(item.building === item.property) {
            return `${item.building} - ${item.tenant}`
        } else {
            return `${item.property} - ${item.tenant}`
        }
    }

    return (
        <div style={styles.container}>
            <Card title="Choose your building" bordered={false} style={{ width: 400, overflow: 'auto' }}>
                <List
                    itemLayout="horizontal"
                    dataSource={data}
                    renderItem={(item) => (
                        <List.Item>
                            <List.Item.Meta
                                title={
                                    <span
                                        style={styles.link}
                                        onClick={() => setCurrentBuilding(item)}
                                    >
                                        { generateName(item) }
                                    </span>
                                }
                            />
                        </List.Item>
                    )}
                />
            </Card>
        </div>
    )
}

export default BuildingPicker
